import { useCursoStore } from "@/store/cursoStore";
import { useGuardianStore } from "@/store/guardianStore";
import { useYearStore } from "@/store/yearStore";
/** Selecciona y persiste el curso activo si aún no hay uno (p. ej. tras login). */
export const bootstrapActiveCursoFromGuardian = async () => {
    const cursoStore = useCursoStore();
    if (cursoStore.hasCurso())
        return true;
    const guardianStore = useGuardianStore();
    if (!guardianStore.courses.length) {
        await guardianStore.fetchGuardianData();
    }
    const courses = guardianStore.courses || [];
    if (!courses.length)
        return false;
    const yearStore = useYearStore();
    yearStore.ensureAñoActivo(courses, undefined);
    const activeYear = yearStore.añoActivo;
    const forYear = activeYear
        ? courses.filter((course) => String(course.year) === String(activeYear))
        : courses;
    const pick = forYear[0] || courses[0];
    if (!pick)
        return false;
    cursoStore.setCurso(pick);
    return true;
};
